import React, { useEffect, useState } from 'react';
import { Box, Button, Container, Grid, TextareaAutosize, Paper, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { ArrowBackIos } from '@mui/icons-material';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import { useNavigate, useParams, Link } from 'react-router-dom';
import moment from 'moment';
import { useRecoilValue, useRecoilState } from 'recoil';
import { toast } from 'react-toastify';

import customer from '../../assets/customer.jpg';
import logo from '../../assets/logo.svg';
import { listComplaintComments, createComplaintComment, resetNewDriverComment, approveRejectComplaint } from '../../repositories/HttpRepository';
import useStyles from './styles';
import { selectedComplaintState } from '../../atoms/DriverComplaintState';
import AttachmentIcon from '@mui/icons-material/Attachment';

Detail.propTypes = {};

const STATUS_SUBMITTED = 'SUBMITTED';
const STATUS_RESOLVED = 'RESOLVED';
const STATUS_REJECTED = 'REJECTED';
const STATUS_ARCHIVED = 'ARCHIVED';

function Detail(props) {
  const navigate = useNavigate();
  const { classes } = useStyles();
  const [answer, setAnswer] = useState(null);
  const { id } = useParams();
  const [replies, setReplies] = useState([]);
  const [open, setOpen] = useState(false);
  const [alertTitle, setAlertTitle] = useState('');
  const [alertContent, setAlertContent] = useState('');
  const [selected, setSelected] = useRecoilState(selectedComplaintState);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [error, setError] = useState(null);
  const [files, setFiles] = useState(null);
  const [driverLogo, setDriverLogo] = useState(customer);

  if (selected.id == null) {
    navigate('/driver-complaints');
  }

  useEffect(() => {
    listComplaintComments(id).then((resp) => {
      if (!resp.ok) {
        return false;
      }

      if (resp.data) {
        setReplies(resp.data);
      }
    });

    // Reset new driver comment
    resetNewDriverComment(id);
  }, []);

  const handleChange = (e) => {
    setAnswer(e.target.value);
    setError('');
  };

  const sendMessage = (status) => {
    if (!answer) {
      setError('Message cannot be empty');
      return false;
    }
    setSelectedStatus(status);
    if (status === STATUS_SUBMITTED) {
      setAlertTitle('Do you want to send a message to this driver?');
      setAlertContent('This message will be sent to the driver.');
    } else if (status === STATUS_REJECTED) {
      setAlertTitle('Do you want to reject this complaint?');
      setAlertContent('This complaint will be rejected and a message will be sent to the driver.');
    } else if (status === STATUS_RESOLVED) {
      setAlertTitle('Do you want to resolve this complaint?');
      setAlertContent('This complaint will be resolved and a message will be sent to the driver.');
    }
    setOpen(true);
  };

  function handleBack(e) {
    navigate('/driver-complaints');
  }

  const replyDisabled = selected.status && [STATUS_REJECTED, STATUS_RESOLVED, STATUS_ARCHIVED].includes(selected.status) && replies ? true : false;
  const classStatus = selected.status ? 'status ' + selected.status.toLowerCase() : '';

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setAnswer('');
  };

  const handleAccept = (status) => {
    if (!answer) {
      setError('Message cannot be empty');
      return false;
    }

    setOpen(false);

    // update status
    if (status === STATUS_RESOLVED) {
      approveRejectComplaint(id, { verdict: answer, is_approve: true });
    }

    // update status
    if (status === STATUS_REJECTED) {
      approveRejectComplaint(id, { verdict: answer, is_approve: false });
    }

    const params = {
      is_driver: false,
      content: answer,
    };

    createComplaintComment(id, params).then((resp) => {
      if (!resp.ok) {
        return false;
      }
      let tmp = [...replies];
      tmp.push({
        is_driver: false,
        name: 'Jitsu',
        created_at: moment().format('DD MMM hh:mm A'),
        content: answer,
      });
      setReplies(tmp);

      // update selected
      setSelected({ ...selected, status: status });
      setAnswer('');
      toast.success('Update successfully !');
    });
  };

  const onloadImage = () => {
    if (selected.driver_logo) {
      setDriverLogo(selected.driver_logo);
    }
  };

  return (
    <Container maxWidth={false} className={classes.root}>
      <div className={classes.root}>
        <Box sx={{ mb: 2 }}>
          <Button variant="contained" startIcon={<ArrowBackIos />} elevation={0} onClick={handleBack} p={20} color="inherit">
            {' '}
            Back
          </Button>
        </Box>
        <Grid container spacing={0} className={classes.main}>
          <Grid size={3}>
            <Paper className={classes.driverInfos}>
              <img src={driverLogo} onLoad={onloadImage} />
              <Box className={classes.driverName}>{selected.driver_name}</Box>
              <Box>{selected.driver_email}</Box>
            </Paper>
          </Grid>

          <Grid size={9}>
            <Paper className={classes.reasonSection}>
              <h3 class={classes.title}>
                Complaint Details [{selected.id}]
                <Button variant="contained" className={classStatus} color="inherit">
                  {selected.status}
                </Button>
              </h3>
              <Box className={classes.row}>
                <label>Complaint content: </label>
                <span>{selected.remark}</span>
              </Box>
              <Box className={classes.row}>
                <label>Contact infos: </label>
                <span>{selected.name}</span>
                <span style={{ paddingLeft: '15px' }}>
                  <PhoneIcon></PhoneIcon> {selected.phone_number}{' '}
                </span>
                <span style={{ paddingLeft: '15px' }}>
                  {' '}
                  <EmailIcon></EmailIcon> {selected.email}{' '}
                </span>
              </Box>
              <Box className={classes.row}>
                <label>Category: </label>
                <span>{selected.category}</span>
              </Box>
              <Box className={classes.row}>
                <label>Incident Date: </label>
                <span>{selected.incident_datetime}</span>
              </Box>
              {selected.files_arr && selected.files_arr && selected.files_arr.length && (
                <Box className={classes.row}>
                  <label>Attach files: </label>
                  {selected.files_arr &&
                    selected.files_arr.map((file, index) => {
                      return (
                        <a target="_blank" class="file" href={file} rel="noreferrer">
                          <AttachmentIcon></AttachmentIcon>
                        </a>
                      );
                    })}
                </Box>
              )}

              <div class="direct-chat-messages">
                {replies &&
                  replies.map((reply, index) => {
                    if (reply.is_driver) {
                      return (
                        <div class="direct-chat-msg">
                          <div class="direct-chat-infos">
                            <span class="direct-chat-name">{selected.driver_name}</span>
                            <span class="direct-chat-timestamp">{moment(reply.created_ts).format('DD MMM hh:mm A')}</span>
                          </div>
                          <img class="direct-chat-img" src={driverLogo} />
                          <div class="direct-chat-text">
                            {reply.content}
                            <Box className={classes.commentFiles}>
                              {reply.files_arr &&
                                reply.files_arr.map((file, index) => {
                                  return (
                                    <a target="_blank" class="file" href={file} rel="noreferrer">
                                      <AttachmentIcon></AttachmentIcon>
                                    </a>
                                  );
                                })}
                            </Box>
                          </div>
                        </div>
                      );
                    }

                    return (
                      <div class="direct-chat-msg right">
                        <div class="direct-chat-infos">
                          <span class="direct-chat-name">Jitsu</span>
                          <span class="direct-chat-timestamp">{moment(reply.created_ts).format('DD MMM hh:mm A')}</span>
                        </div>
                        <img class="direct-chat-img" src={logo} alt="message user image" />
                        <div class="direct-chat-text">{reply.content}</div>
                      </div>
                    );
                  })}
              </div>

              <div class="box-footer">
                <Box>
                  <TextareaAutosize
                    value={answer}
                    onChange={handleChange}
                    variant="outlined"
                    id="standard-start-adornment"
                    className={classes.answerInput}
                    placeholder={'Type a message'}
                    minRows={5}
                    disabled={replyDisabled}
                    maxLength={2048}
                  />
                  <Box className={classes.error}>{error}</Box>
                </Box>
                <Box item xs={12}>
                  <Button onClick={() => sendMessage(STATUS_SUBMITTED)} variant="contained" color="primary" className={classes.btnPrimary} disabled={replyDisabled}>
                    REPLY
                  </Button>
                  <Button onClick={() => sendMessage(STATUS_RESOLVED)} variant="contained" color="success" className={classes.btnApprove} disabled={replyDisabled}>
                    RESOLVE
                  </Button>
                </Box>
              </div>
            </Paper>
          </Grid>
        </Grid>
      </div>
      <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{alertTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{alertContent}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Disagree
          </Button>
          <Button onClick={() => handleAccept(selectedStatus)} color="primary" autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default Detail;
